import React, { useEffect } from "react";
import { TinyUser } from "../../../types/user/TinyUser";
import {
  concatUsername,
  getRandomProfileColor,
} from "../../../utils/profileUtils";
import { IsValidString } from "../../../utils/stringUtils";
import useTranslation from "../../../hooks/useTranslation";
import useLocale from "../../../hooks/useLocale";

interface navigateToProfile {
  navigate: boolean;
  navigateFunction: () => void;
}

type CustomUserGridInfoProp = {
  localizationText?: string;
  label?: string | undefined;
  userInfo: TinyUser;
  selected?: boolean;
  iconCls?: string;
  navigateToProfile?: navigateToProfile;
  star?: boolean;
  showWarningIcon?: boolean;
  isUltimateLicense?: boolean;
};

const CustomUserGridInfoLocalizationProp: React.FC<CustomUserGridInfoProp> = ({
  localizationText,
  label,
  userInfo,
  iconCls,
  navigateToProfile,
  star,
  isUltimateLicense,
  showWarningIcon,
}) => {
  var bgClassName = getRandomProfileColor(userInfo.id);
  var firstName = IsValidString(userInfo.firstName) ? userInfo.firstName : "";
  var lastName = IsValidString(userInfo.lastName) ? userInfo.lastName : "";
  var userName = `${firstName} ${lastName}`.trim();

  var isImageAvailable = IsValidString(userInfo.image);
  var isUserNameAvailable = IsValidString(userName);
  var isEmailAvailable = IsValidString(userInfo.email);
  var isPhoneNumberAvailable = IsValidString(userInfo.phoneNo);
  var userInitials = isUserNameAvailable
    ? userName
        .split(" ")
        .map((n: string) => n[0])
        .join("")
    : "";

  var header = isUserNameAvailable
    ? concatUsername(
        userInfo.firstName ? userInfo.firstName : "",
        userInfo.lastName ? userInfo.lastName : ""
      )
    : isEmailAvailable
    ? userInfo.email
    : userInfo.phoneNo;
  var content = isUserNameAvailable
    ? isEmailAvailable
      ? userInfo.email
      : userInfo.phoneNo
    : "";

  return (
    <div className="tblUsr w-100">
      <div className="topUsrAreaPic">
        <div className="topUsrAreaPic-i">
          <div className={"contact-list-icon " + bgClassName}>
            <div
              className={`contact-list-icon-txt ${
                navigateToProfile?.navigate ? "cursor-pointer" : ""
              }`}
              onClick={
                navigateToProfile && navigateToProfile?.navigate
                  ? navigateToProfile.navigateFunction
                  : () => {}
              }
            >
              {isImageAvailable && (
                <div className="contact-list-icon-img ">
                  <img
                    src={require("../../../assets/images/user-img-2.jpg")}
                    alt={"user"}
                  />
                </div>
              )}
              {!isImageAvailable && isUserNameAvailable && userInitials}
              {!isImageAvailable && !isUserNameAvailable && (
                <span className="fs-16">
                  <i className={`${iconCls ? iconCls : "bi bi-telephone"}`}></i>
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="topUsrAreaPic-tx hoverTextFull">
          {label !== undefined && label.trim() !== "" && (
            <span className="fs-13 font-weight-semi line-height-1">
              {label}
            </span>
          )}
          <span
            onClick={
              navigateToProfile && navigateToProfile?.navigate
                ? navigateToProfile.navigateFunction
                : () => {}
            }
            className={`text-primary font-weight-semi ${
              navigateToProfile?.navigate ? "cursor-default" : "cursor-pointer"
            } text-decoration-none float-left w-100 line-height-2 mx-td-spn viewFullWordHover`}
            title={header}
          >
            {header}
            {star && (
              <span
                style={{
                  color: "red",
                  padding: "0 0 0 3px",
                }}
              >
                *
              </span>
            )}
            {showWarningIcon && !isUltimateLicense && (
              <span title={localizationText}>
                <i className="bi bi-exclamation-triangle-fill text-danger ml-2"></i>
              </span>
            )}
          </span>
          <span
            onClick={
              navigateToProfile && navigateToProfile?.navigate
                ? navigateToProfile.navigateFunction
                : () => {}
            }
            className={`text-muted fs-13 line-height-2 mx-td-spn viewFullWordHover ${
              navigateToProfile?.navigate ? "cursor-default" : "cursor-pointer"
            }`}
            title={content}
          >
            {content}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomUserGridInfoLocalizationProp;
